import { PromoCodeRejectionReason } from "../enums/promo-code-rejection-reason.enum";

export class PromoCodeValidationRequestDto {
	transactionType: number;
	checkAmount: number;
	checkDate: string;
	checkKey: string;
	menuItemKeys: number[];
	promoCode: string;

	public constructor(init?: Partial<PromoCodeValidationRequestDto>) {
		Object.assign(this, init);
	}
}

export class PromoCodeValidationResponseDto {
	appliedPromoCodes: PromoCodeAppliedCodes[] = [];
	rejectionResonseReason: number;
	rejectionMessage?: string;

	public constructor(init?: Partial<PromoCodeValidationResponseDto>) {
		Object.assign(this, init);
		if (this.rejectionResonseReason) {
			this.rejectionMessage = this.createRejectionMessage(this.rejectionResonseReason);
		}
	}

	createRejectionMessage(rejectionResonseReason: number) {
		switch (rejectionResonseReason) {
			case PromoCodeRejectionReason.INCORRECTTRANSACTIONTYPE:
				return `Sorry, this code can't be used for this transaction type`;
			case PromoCodeRejectionReason.MAXUSEREACHED:
				return `This code uas reached its maximum uses.`;
			case PromoCodeRejectionReason.NOAPPLICATIONITEMS:
				return `Your order does not include any items for this code.`;
			case PromoCodeRejectionReason.NOREQUIREDITEMS:
				return `Sorry, your order is missing some items required for this promotion.`;
			case PromoCodeRejectionReason.NOTACTIVE:
				return `This code is not active right now.`;
			case PromoCodeRejectionReason.OUTSIDEDAYOFUSE:
				return `This code is not available today.`;
			case PromoCodeRejectionReason.OUTSIDEOFDATES:
				return `This code is outside of its eligible dates.`;
		}
	}
}

export class PromoCodeAppliedCodes {
	menuItemKey: number;
	value: number;
	promoCodeKey: string;

	public constructor(init?: Partial<PromoCodeAppliedCodes>) {
		Object.assign(this, init);
	}
}

export class PromoCodeUsage {
	promoCodeKey: string;
	tranDateTime: string;
	checkKey: string;
	customerKey?: string;
	amount: number;

	public constructor(init?: Partial<PromoCodeUsage>) {
		Object.assign(this, init);
	}
}
